import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import './ControlEstadistico.css';

const GRAFANA_BASE = import.meta.env.VITE_API_URL;
const DASHBOARD_SLUG = 'control-estadistico';
const THEME = 'dark';
const FROM = 'now-6h';
const TO = 'now';

// UIDs de los dashboards
const DASHBOARD_UIDS = {
  'SPC 1': 'f185f21f-60eb-4d8f-b2f8-ff3b8efcd503',
  'SPC 2': 'a2be0347-0bef-456d-92cb-aa6d64f760ef'
};

const ControlEstadistico = () => {
  const { t } = useLanguage();
  const [selectedSpc, setSelectedSpc] = useState('SPC 2'); // Por defecto SPC 2 (el actual)
  
  const dashboardUid = DASHBOARD_UIDS[selectedSpc];
  const iframeUrl = `${GRAFANA_BASE}/d/${dashboardUid}/${DASHBOARD_SLUG}?orgId=1&kiosk&theme=${THEME}&from=${FROM}&to=${TO}`;

  return (
    <div className="control-estadistico">
      <header className="control-estadistico-header">
        <h1>📊 Control Estadístico</h1>
        <p>Control estadístico de procesos (SPC)</p>
      </header>
      
      {/* Menú de selección SPC */}
      <div className="control-estadistico-menu">
        <button
          className={`control-estadistico-menu-item ${selectedSpc === 'SPC 1' ? 'active' : ''}`}
          onClick={() => setSelectedSpc('SPC 1')}
        >
          SPC 1
        </button>
        <button
          className={`control-estadistico-menu-item ${selectedSpc === 'SPC 2' ? 'active' : ''}`}
          onClick={() => setSelectedSpc('SPC 2')}
        >
          SPC 2
        </button>
      </div>

      <div className="control-estadistico-iframe-container">
        <iframe
          key={dashboardUid} // Key para forzar recarga cuando cambia el dashboard
          src={iframeUrl}
          title={`Dashboard Grafana - Control Estadístico - ${selectedSpc}`}
          className="control-estadistico-grafana-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default ControlEstadistico;